import { Injectable, inject } from '@angular/core';
import { Functions, httpsCallable } from '@angular/fire/functions';
import { Observable, defer, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RpcService {
  private functions = inject(Functions);

  getUserDisplayInfo(eventKey: string, uids: string[]): Observable<{[uid: string]: string}> {
    return defer(() => httpsCallable<{}, {[uid: string]: string}>(this.functions, 'volunteer-getUserEmails')({eventKey, uids: uids.join(',')})).pipe(
      map(response => response.data),
    );
  }
}
